import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

export default function PunSeca ({ date }) {
  return (
    <>
      <Stack>
        <Typography variant='body1'>
          Profesional encargado: Mercedes Penso Balseiro
        </Typography>
        <Typography variant='body1'>
          Fecha del tratamiento: {date}
        </Typography>
      </Stack>
      <Typography fontWeight='bold'>Introducción</Typography>
      <Typography variant='body1'>
        La punción seca es una técnica terapéutica utilizada en fisioterapia para tratar puntos gatillo
        miofasciales, que son áreas de tensión muscular. La técnica implica el uso de una aguja fina, similar
        a la de acupuntura, que se inserta en el músculo afectado para liberar la tensión y mejorar la función
        muscular. A continuación, se le explican los posibles riesgos, beneficios y alternativas de este
        tratamiento
      </Typography>
      <Typography fontWeight='bold'>Descripción de la técnica</Typography>
      <Typography variant='body1'>
        La punción seca consiste en la inserción de una aguja estéril en los músculos donde se encuentran
        los puntos gatillo. Esta técnica busca aliviar el dolor muscular y mejorar el rango de movimiento. El
        procedimiento se realiza bajo condiciones controladas y de acuerdo con las pautas de seguridad para
        minimizar el riesgo de efectos adversos.
      </Typography>
      <Typography fontWeight='bold'>Beneficios esperados</Typography>
      <ul>
        <li>Reducción del dolor muscular.</li>
        <li>Mejora de la función muscular.</li>
        <li>Alivio de la tensión muscular localizada.</li>
        <li>Aumento del rango de movimiento en la zona tratada.</li>
      </ul>
      <Typography fontWeight='bold'>Posibles riesgos y efectos secundarios</Typography>
      <Typography variant='body1'>
        Aunque la punción seca es una técnica generalmente segura, puede
        presentar algunos efectos secundarios temporales, entre los que se
        incluyen:
      </Typography>
      <ul>
        <li>Dolor o molestia en el área tratada.</li>
        <li>Enrojecimiento o hematomas leves.</li>
        <li>Sensación de fatiga o debilidad temporal.</li>
        <li>Reacción leve similar a un calambre en la zona tratada.</li>
        <li>Rara vez, se puede presentar infección o daño a tejidos cercanos.</li>
      </ul>
      <Typography fontWeight='bold'>Consentimiento</Typography>
      <Typography variant='body1'>
        He leído y comprendido la información proporcionada sobre la técnica de
        punción seca, incluyendo sus beneficios, posibles riesgos y alternativas.
        He tenido la oportunidad de hacer preguntas sobre el tratamiento y estas
        han sido respondidas de manera satisfactoria.
      </Typography>
      <Typography variant='body1'>
        Entiendo que la punción seca es un tratamiento voluntario y que puedo
        optar por no realizarlo en cualquier momento sin que esto afecte el
        resto de mi tratamiento fisioterapéutico.
      </Typography>
      <Typography fontWeight='bold'>Autorización</Typography>
      <Typography variant='body1'>
        Con mi firma, autorizo al fisioterapeuta o profesional de la salud que
        me atiende a realizar el tratamiento de punción seca descrito en este
        formulario.
      </Typography>
      <Stack direction='row' spacing={20} mt={4} mb={10}>
        <Typography variant='subtitle1'>
          Firma del profesional de la salud:
        </Typography>
        <Typography variant='subtitle1'>Firma del paciente:</Typography>
      </Stack>
    </>
  )
}
